import { useEffect } from 'react';

const SITE_URL = (import.meta.env.VITE_SITE_URL as string | undefined) || 'https://rwa99.cn';

export default function BBSSEOHead() {
  useEffect(() => {
    // Page title & meta
    document.title = 'RWA99 社区论坛 | 区块链RWA合规交流社区 · 注册发帖 · 文件分享';

    const setMeta = (name: string, content: string, prop = false) => {
      const attr = prop ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.content = content;
    };

    setMeta('description', 'RWA99 社区论坛 — 注册即可参与区块链、RWA真实世界资产代币化合规知识交流，上传研究报告，探讨政策解读、技术方案与投资合规路径。');
    setMeta('keywords', 'RWA论坛,区块链社区,RWA合规交流,真实世界资产讨论,VATP政策解读,区块链研究报告');
    setMeta('robots', 'index, follow');
    setMeta('og:title', 'RWA99 社区论坛 | 区块链RWA合规交流', true);
    setMeta('og:description', '注册加入RWA99社区，与业内人士共同探讨区块链、RWA代币化政策、技术与合规实践。', true);
    setMeta('og:type', 'website', true);
    setMeta('og:url', `${SITE_URL}/bbs`, true);

    // Schema.org JSON-LD
    const existing = document.querySelectorAll('script[data-bbs-jsonld]');
    existing.forEach((el) => el.remove());

    const schemas = [
      {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        '@id': `${SITE_URL}/bbs#webpage`,
        url: `${SITE_URL}/bbs`,
        name: 'RWA99 社区论坛 | 区块链RWA合规交流社区',
        description: 'RWA99 社区论坛 — 区块链与真实世界资产代币化合规交流平台，用户可注册发帖、上传研究报告、参与政策解读讨论。',
        inLanguage: 'zh-CN',
        isPartOf: { '@id': `${SITE_URL}/#website` },
        publisher: { '@id': `${SITE_URL}/#organization` },
        datePublished: '2026-01-01',
        dateModified: '2026-03-30',
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: '首页', item: SITE_URL },
            { '@type': 'ListItem', position: 2, name: '社区论坛', item: `${SITE_URL}/bbs` },
          ],
        },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'DiscussionForumPosting',
        '@id': `${SITE_URL}/bbs#forum`,
        url: `${SITE_URL}/bbs`,
        headline: 'RWA99 社区论坛',
        description: '区块链与RWA真实世界资产代币化合规知识交流社区',
        keywords: ['RWA', '区块链', '合规', '代币化', 'VATP', '香港SFC'],
        author: {
          '@type': 'Organization',
          '@id': `${SITE_URL}/#organization`,
          name: 'RWA99.cn',
        },
        publisher: {
          '@type': 'Organization',
          '@id': `${SITE_URL}/#organization`,
          name: 'RWA99.cn',
          url: SITE_URL,
        },
        datePublished: '2026-01-01',
        dateModified: '2026-03-30',
        inLanguage: 'zh-CN',
        isPartOf: { '@id': `${SITE_URL}/#website` },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: [
          {
            '@type': 'Question',
            name: '如何在RWA99社区论坛注册？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '点击页面右上角"登录/注册"按钮，填写用户名、邮箱和密码即可完成注册，注册后可发帖、回复及上传研究报告。',
            },
          },
          {
            '@type': 'Question',
            name: 'RWA99论坛允许上传哪些类型的文件？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '支持上传PDF研究报告、Word文档、Excel表格及PowerPoint演示文稿，方便用户分享RWA与区块链领域的专业见解和方案。',
            },
          },
          {
            '@type': 'Question',
            name: '论坛有哪些讨论版块？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '论坛设有政策法规解读、技术研究、案例分析、资讯快讯、资料共享及招募合作等专业版块，覆盖RWA生态全链条。',
            },
          },
        ],
      },
    ];

    schemas.forEach((schema) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute('data-bbs-jsonld', 'true');
      script.textContent = JSON.stringify(schema, null, 2);
      document.head.appendChild(script);
    });

    return () => {
      document.querySelectorAll('script[data-bbs-jsonld]').forEach((el) => el.remove());
    };
  }, []);

  return null;
}
